<template>
    <v-container fluid class="pa-5">

      <div v-for="(elem, index) in data" :id="index" v-bind:key="index">

        <v-row>
          <HeaderLookbook :header="elem.meta" :id="'collection_'+index"></HeaderLookbook>
        </v-row>

        <v-row v-for="(products, index2) in elem.productGrouped" :key="'products_' + index2" >
          <v-col cols="12" class="pb-0">
            <TemplateLookbook :products="products"></TemplateLookbook>
          </v-col>
        </v-row>

      </div>

      <!--
      <v-row>
          <HeaderLookbook :header="riviera" id="riviera"></HeaderLookbook>
      </v-row>

      <v-row v-for="(products, index) in rivieraProductGrouped" :key="'riviera' + index" >
          <v-col cols="12" class="pb-0">
              <TemplateLookbook :products="products"></TemplateLookbook>
          </v-col>
      </v-row>-->

      <v-bottom-sheet v-model="sheet">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              fixed
              bottom
          >
            {{$t("lookbook.collectionButton")}}
          </v-btn>
        </template>
        <v-list>
          <v-subheader>{{$t("lookbook.scegliCollezione")}}</v-subheader>

          <v-list-item v-for="(elem,index) in data" v-bind:key="'scroll_'+index"
              @click="scrollToTarget('#collection_'+index)"
          >
            <v-list-item-title> {{elem.meta.title}} </v-list-item-title>
          </v-list-item>

        </v-list>
      </v-bottom-sheet>

    </v-container>
</template>

<script>

    import HeaderLookbook from "../components/HeaderLookbook";
    import TemplateLookbook from "../components/TemplateLookbook";
    import {
      jungle, jungleProducts,
      maiolica, maiolicaProducts,
      paisley, paisleyProducts,
      ramadan, ramadanProducts,
      riviera, rivieraProducts,
      whiteCouture, whiteCoutureProducts
    } from "../assets/lookbook5";

    export default {
        name: "Lookbook5",
        components: {TemplateLookbook, HeaderLookbook},

        data: () => ({
          sheet: false,
          optionScroll: {
            duration: 300,
            offset: 0,
            easing: 'easeInOutCubic',
          },
          data: [
            {
              meta: riviera,
              products: rivieraProducts,
              productGrouped: undefined
            },
            {
              meta: jungle,
              products: jungleProducts,
              productGrouped: undefined
            },
            {
              meta: maiolica,
              products: maiolicaProducts,
              productGrouped: undefined
            },
            {
              meta: whiteCouture,
              products: whiteCoutureProducts,
              productGrouped: undefined
            },
            {
              meta: paisley,
              products: paisleyProducts,
              productGrouped: undefined
            },
            {
              meta: ramadan,
              products: ramadanProducts,
              productGrouped: undefined
            }
          ],
        }),

        created() {
          for (var i = 0; i < this.data.length; i++) {
            this.data[i].productGrouped = this.listToMatrix(this.data[i].products, 11)
          }
        },

        methods:{
          listToMatrix(list, elementsPerSubArray) {
              var matrix = [], i, k;

              for (i = 0, k = -1; i < list.length; i++) {
                  if (i % elementsPerSubArray === 0) {
                      k++;
                      matrix[k] = [];
                  }

                  matrix[k].push(list[i]);
              }
              return matrix;
          },
          scrollToTarget(target){
            this.sheet = false;
            this.$vuetify.goTo(target, this.optionScroll)
          }
        }

    }
</script>

<style scoped>

</style>
